import { Component, OnInit } from '@angular/core';
import { ListResponse } from '../../../../../../models/list-response';
import { DocumentPolicy, DocumentTemplate } from '../../../../../../models/document-template';
import { AccountService } from '../../../../../../services/account/account.service';
import { DocumentTemplateService } from '../../../../../../services/document-template/document-template.service';

@Component({
  selector: 'app-document-policies',
  templateUrl: './document-policies.component.html',
  styleUrls: ['./document-policies.component.css']
})
export class DocumentPoliciesComponent implements OnInit {

  public documentPolicyList: ListResponse<DocumentPolicy>;
  public loadingDocumentPolicies = false;

  // Document templates must be loaded in order to show the names of the
  // policies' containing templates.
  public documentTemplateList: ListResponse<DocumentTemplate>;
  public loadingDocumentTemplates = false;
  public documentTemplateIdToName: {[key: number]: string} = null;

  public serverError: number = null;

  // Make browser history available to the template.
  public history: History;

  constructor(
    public accountService: AccountService,
    private documentTemplateService: DocumentTemplateService
  ) {}

  ngOnInit() {
    // TODO: Replace with more specific permission?
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }

    // Make browser history available to the template.
    this.history = history;

    this.loadDocumentPolicies();
    this.loadDocumentTemplates();
  }

  public loadDocumentPolicies() {
    this.loadingDocumentPolicies = true;

    this.documentTemplateService
      .getDocumentPolicies(1, 100)
      .then(response => {
        this.documentPolicyList = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingDocumentPolicies = false;
      });
  }

  public loadDocumentTemplates() {
    this.loadingDocumentTemplates = true;

    this.documentTemplateService
      .getDocumentTemplates(1, 100)
      .then(response => {
        this.documentTemplateList = response;

        this.documentTemplateIdToName = {};
        for (const documentTemplate of this.documentTemplateList.results) {
          this.documentTemplateIdToName[documentTemplate.id] = documentTemplate.name;
        }
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingDocumentTemplates = false;
      });
  }

  /**
   * Whether a non-zero number of results have been loaded.
   */
  public resultsPresent(): boolean {
    return (
      this.documentPolicyList &&
      this.documentPolicyList.results &&
      (this.documentPolicyList.results.length > 0)
    );
  }

}
